"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ActiveNowIcon", {
  enumerable: true,
  get: function get() {
    return _ActiveNowIcon.ActiveNowIcon;
  }
});
Object.defineProperty(exports, "AddItemIcon", {
  enumerable: true,
  get: function get() {
    return _AddItemIcon.AddItemIcon;
  }
});
Object.defineProperty(exports, "AddSquareIcon", {
  enumerable: true,
  get: function get() {
    return _AddSquareIcon.AddSquareIcon;
  }
});
Object.defineProperty(exports, "AddressIcon", {
  enumerable: true,
  get: function get() {
    return _AddressIcon.AddressIcon;
  }
});
Object.defineProperty(exports, "AlertFullIcon", {
  enumerable: true,
  get: function get() {
    return _AlertFullIcon.AlertFullIcon;
  }
});
Object.defineProperty(exports, "AlertIcon", {
  enumerable: true,
  get: function get() {
    return _AlertIcon.AlertIcon;
  }
});
Object.defineProperty(exports, "AlertInfoIcon", {
  enumerable: true,
  get: function get() {
    return _AlertInfoIcon.AlertInfoIcon;
  }
});
Object.defineProperty(exports, "AppleIcon", {
  enumerable: true,
  get: function get() {
    return _AppleIcon.AppleIcon;
  }
});
Object.defineProperty(exports, "ArmorIcon", {
  enumerable: true,
  get: function get() {
    return _ArmorIcon.ArmorIcon;
  }
});
Object.defineProperty(exports, "ArrowIcon", {
  enumerable: true,
  get: function get() {
    return _ArrowIcon.ArrowIcon;
  }
});
Object.defineProperty(exports, "ArrowLeftIcon", {
  enumerable: true,
  get: function get() {
    return _ArrowLeftIcon.ArrowLeftIcon;
  }
});
Object.defineProperty(exports, "ArrowRightIcon", {
  enumerable: true,
  get: function get() {
    return _ArrowRightIcon.ArrowRightIcon;
  }
});
Object.defineProperty(exports, "ArrowUpDownIcon", {
  enumerable: true,
  get: function get() {
    return _ArrowUpDownIcon.ArrowUpDownIcon;
  }
});
Object.defineProperty(exports, "BardIcon", {
  enumerable: true,
  get: function get() {
    return _BardIcon.BardIcon;
  }
});
Object.defineProperty(exports, "BlackMageIcon", {
  enumerable: true,
  get: function get() {
    return _BlackMageIcon.BlackMageIcon;
  }
});
Object.defineProperty(exports, "BookmarkIcon", {
  enumerable: true,
  get: function get() {
    return _BookmarkIcon.BookmarkIcon;
  }
});
Object.defineProperty(exports, "BroomIcon", {
  enumerable: true,
  get: function get() {
    return _BroomIcon.BroomIcon;
  }
});
Object.defineProperty(exports, "BurgerIcon", {
  enumerable: true,
  get: function get() {
    return _BurgerIcon.BurgerIcon;
  }
});
Object.defineProperty(exports, "CalendarIcon", {
  enumerable: true,
  get: function get() {
    return _CalendarIcon.CalendarIcon;
  }
});
Object.defineProperty(exports, "ChemistIcon", {
  enumerable: true,
  get: function get() {
    return _ChemistIcon.ChemistIcon;
  }
});
Object.defineProperty(exports, "ClockIcon", {
  enumerable: true,
  get: function get() {
    return _ClockIcon.ClockIcon;
  }
});
Object.defineProperty(exports, "CloseIcon", {
  enumerable: true,
  get: function get() {
    return _CloseIcon.CloseIcon;
  }
});
Object.defineProperty(exports, "CodeIcon", {
  enumerable: true,
  get: function get() {
    return _CodeIcon.CodeIcon;
  }
});
Object.defineProperty(exports, "CoinIcon", {
  enumerable: true,
  get: function get() {
    return _CoinIcon.CoinIcon;
  }
});
Object.defineProperty(exports, "CrownIcon", {
  enumerable: true,
  get: function get() {
    return _CrownIcon.CrownIcon;
  }
});
Object.defineProperty(exports, "DamageCompareIcon", {
  enumerable: true,
  get: function get() {
    return _DamageCompareIcon.DamageCompareIcon;
  }
});
Object.defineProperty(exports, "DamageIcon", {
  enumerable: true,
  get: function get() {
    return _DamageIcon.DamageIcon;
  }
});
Object.defineProperty(exports, "DefaultLogoIcon", {
  enumerable: true,
  get: function get() {
    return _DefaultLogoIcon.DefaultLogoIcon;
  }
});
Object.defineProperty(exports, "DexterityIcon", {
  enumerable: true,
  get: function get() {
    return _DexterityIcon.DexterityIcon;
  }
});
Object.defineProperty(exports, "DiamondIcon", {
  enumerable: true,
  get: function get() {
    return _DiamondIcon.DiamondIcon;
  }
});
Object.defineProperty(exports, "DiceIcon", {
  enumerable: true,
  get: function get() {
    return _DiceIcon.DiceIcon;
  }
});
Object.defineProperty(exports, "DisconnectIcon", {
  enumerable: true,
  get: function get() {
    return _DisconnectIcon.DisconnectIcon;
  }
});
Object.defineProperty(exports, "DrakoIcon", {
  enumerable: true,
  get: function get() {
    return _DrakoIcon.DrakoIcon;
  }
});
Object.defineProperty(exports, "DruidIcon", {
  enumerable: true,
  get: function get() {
    return _DruidIcon.DruidIcon;
  }
});
Object.defineProperty(exports, "DrumIcon", {
  enumerable: true,
  get: function get() {
    return _DrumIcon.DrumIcon;
  }
});
Object.defineProperty(exports, "EyeIcon", {
  enumerable: true,
  get: function get() {
    return _EyeIcon.EyeIcon;
  }
});
Object.defineProperty(exports, "EyeIconOutline", {
  enumerable: true,
  get: function get() {
    return _EyeIconOutline.EyeIconOutline;
  }
});
Object.defineProperty(exports, "EyeSlashIcon", {
  enumerable: true,
  get: function get() {
    return _EyeSlashIcon.EyeSlashIcon;
  }
});
Object.defineProperty(exports, "FacebookIcon", {
  enumerable: true,
  get: function get() {
    return _FacebookIcon.FacebookIcon;
  }
});
Object.defineProperty(exports, "FiltersIcon", {
  enumerable: true,
  get: function get() {
    return _FiltersIcon.FiltersIcon;
  }
});
Object.defineProperty(exports, "FireIcon", {
  enumerable: true,
  get: function get() {
    return _FireIcon.FireIcon;
  }
});
Object.defineProperty(exports, "GameIcon", {
  enumerable: true,
  get: function get() {
    return _GameIcon.GameIcon;
  }
});
Object.defineProperty(exports, "GiftIcon", {
  enumerable: true,
  get: function get() {
    return _GiftIcon.GiftIcon;
  }
});
Object.defineProperty(exports, "GoogleIcon", {
  enumerable: true,
  get: function get() {
    return _GoogleIcon.GoogleIcon;
  }
});
Object.defineProperty(exports, "GroupSaleIcon", {
  enumerable: true,
  get: function get() {
    return _GroupSaleIcon.GroupSaleIcon;
  }
});
Object.defineProperty(exports, "HashTagIcon", {
  enumerable: true,
  get: function get() {
    return _HashTagIcon.HashTagIcon;
  }
});
Object.defineProperty(exports, "HawkKnightIcon", {
  enumerable: true,
  get: function get() {
    return _HawkKnightIcon.HawkKnightIcon;
  }
});
Object.defineProperty(exports, "HealthIcon", {
  enumerable: true,
  get: function get() {
    return _HealthIcon.HealthIcon;
  }
});
Object.defineProperty(exports, "ImageCarouselIcon", {
  enumerable: true,
  get: function get() {
    return _ImageCarouselIcon.ImageCarouselIcon;
  }
});
Object.defineProperty(exports, "InboxIcon", {
  enumerable: true,
  get: function get() {
    return _InboxIcon.InboxIcon;
  }
});
Object.defineProperty(exports, "InfoCircleIcon", {
  enumerable: true,
  get: function get() {
    return _InfoCircleIcon.InfoCircleIcon;
  }
});
Object.defineProperty(exports, "InfoIcon", {
  enumerable: true,
  get: function get() {
    return _InfoIcon.InfoIcon;
  }
});
Object.defineProperty(exports, "IntelligenceIcon", {
  enumerable: true,
  get: function get() {
    return _IntelligenceIcon.IntelligenceIcon;
  }
});
Object.defineProperty(exports, "KnightIcon", {
  enumerable: true,
  get: function get() {
    return _KnightIcon.KnightIcon;
  }
});
Object.defineProperty(exports, "LeftArrowWithBackground", {
  enumerable: true,
  get: function get() {
    return _LeftArrowWithBackground.LeftArrowWithBackground;
  }
});
Object.defineProperty(exports, "LibraryIcon", {
  enumerable: true,
  get: function get() {
    return _LibraryIcon.LibraryIcon;
  }
});
Object.defineProperty(exports, "LogoIcon", {
  enumerable: true,
  get: function get() {
    return _LogoIcon.LogoIcon;
  }
});
Object.defineProperty(exports, "LuckIcon", {
  enumerable: true,
  get: function get() {
    return _LuckIcon.LuckIcon;
  }
});
Object.defineProperty(exports, "MagicIcon", {
  enumerable: true,
  get: function get() {
    return _MagicIcon.MagicIcon;
  }
});
Object.defineProperty(exports, "MonkIcon", {
  enumerable: true,
  get: function get() {
    return _MonkIcon.MonkIcon;
  }
});
Object.defineProperty(exports, "MoonIcon", {
  enumerable: true,
  get: function get() {
    return _MoonIcon.MoonIcon;
  }
});
Object.defineProperty(exports, "MovementIcon", {
  enumerable: true,
  get: function get() {
    return _MovementIcon.MovementIcon;
  }
});
Object.defineProperty(exports, "NecromancerIcon", {
  enumerable: true,
  get: function get() {
    return _NecromancerIcon.NecromancerIcon;
  }
});
Object.defineProperty(exports, "NewTextIcon", {
  enumerable: true,
  get: function get() {
    return _NewTextIcon.NewTextIcon;
  }
});
Object.defineProperty(exports, "NinjaIcon", {
  enumerable: true,
  get: function get() {
    return _NinjaIcon.NinjaIcon;
  }
});
Object.defineProperty(exports, "NotFoundIcon", {
  enumerable: true,
  get: function get() {
    return _NotFoundIcon.NotFoundIcon;
  }
});
Object.defineProperty(exports, "NotificationIcon", {
  enumerable: true,
  get: function get() {
    return _NotificationIcon.NotificationIcon;
  }
});
Object.defineProperty(exports, "OfferIcon", {
  enumerable: true,
  get: function get() {
    return _OfferIcon.OfferIcon;
  }
});
Object.defineProperty(exports, "PaperPlaneIcon", {
  enumerable: true,
  get: function get() {
    return _PaperPlaneIcon.PaperPlaneIcon;
  }
});
Object.defineProperty(exports, "PenToSquareIcon", {
  enumerable: true,
  get: function get() {
    return _PenToSquareIcon.PenToSquareIcon;
  }
});
Object.defineProperty(exports, "PetIcon", {
  enumerable: true,
  get: function get() {
    return _PetIcon.PetIcon;
  }
});
Object.defineProperty(exports, "PetsPlusVoxelIcon", {
  enumerable: true,
  get: function get() {
    return _PetsPlusVoxelIcon.PetsPlusVoxelIcon;
  }
});
Object.defineProperty(exports, "PirateIcon", {
  enumerable: true,
  get: function get() {
    return _PirateIcon.PirateIcon;
  }
});
Object.defineProperty(exports, "PixelArrowIcon", {
  enumerable: true,
  get: function get() {
    return _PixelArrowIcon.PixelArrowIcon;
  }
});
Object.defineProperty(exports, "PlayIcon", {
  enumerable: true,
  get: function get() {
    return _PlayIcon.PlayIcon;
  }
});
Object.defineProperty(exports, "PriestIcon", {
  enumerable: true,
  get: function get() {
    return _PriestIcon.PriestIcon;
  }
});
Object.defineProperty(exports, "RangerIcon", {
  enumerable: true,
  get: function get() {
    return _RangerIcon.RangerIcon;
  }
});
Object.defineProperty(exports, "RankIcon", {
  enumerable: true,
  get: function get() {
    return _RankIcon.RankIcon;
  }
});
Object.defineProperty(exports, "RecipeIcon", {
  enumerable: true,
  get: function get() {
    return _RecipeIcon.RecipeIcon;
  }
});
Object.defineProperty(exports, "RefreshIcon", {
  enumerable: true,
  get: function get() {
    return _RefreshIcon.RefreshIcon;
  }
});
Object.defineProperty(exports, "RemoveItemIcon", {
  enumerable: true,
  get: function get() {
    return _RemoveItemIcon.RemoveItemIcon;
  }
});
Object.defineProperty(exports, "RentalIcon", {
  enumerable: true,
  get: function get() {
    return _RentalIcon.RentalIcon;
  }
});
Object.defineProperty(exports, "ReservedLockIcon", {
  enumerable: true,
  get: function get() {
    return _ReservedLockIcon.ReservedLockIcon;
  }
});
Object.defineProperty(exports, "ResizeIcon", {
  enumerable: true,
  get: function get() {
    return _ResizeIcon.ResizeIcon;
  }
});
Object.defineProperty(exports, "RoboIcon", {
  enumerable: true,
  get: function get() {
    return _RoboIcon.RoboIcon;
  }
});
Object.defineProperty(exports, "SadIcon", {
  enumerable: true,
  get: function get() {
    return _SadIcon.SadIcon;
  }
});
Object.defineProperty(exports, "SamuraiIcon", {
  enumerable: true,
  get: function get() {
    return _SamuraiIcon.SamuraiIcon;
  }
});
Object.defineProperty(exports, "SearchIcon", {
  enumerable: true,
  get: function get() {
    return _SearchIcon.SearchIcon;
  }
});
Object.defineProperty(exports, "ShareIcon", {
  enumerable: true,
  get: function get() {
    return _ShareIcon.ShareIcon;
  }
});
Object.defineProperty(exports, "ShopIcon", {
  enumerable: true,
  get: function get() {
    return _ShopIcon.ShopIcon;
  }
});
Object.defineProperty(exports, "SkullIcon", {
  enumerable: true,
  get: function get() {
    return _SkullIcon.SkullIcon;
  }
});
Object.defineProperty(exports, "SquirrelIcon", {
  enumerable: true,
  get: function get() {
    return _SquirrelIcon.SquirrelIcon;
  }
});
Object.defineProperty(exports, "StarIcon", {
  enumerable: true,
  get: function get() {
    return _StarIcon.StarIcon;
  }
});
Object.defineProperty(exports, "StrengthIcon", {
  enumerable: true,
  get: function get() {
    return _StrengthIcon.StrengthIcon;
  }
});
Object.defineProperty(exports, "SunIcon", {
  enumerable: true,
  get: function get() {
    return _SunIcon.SunIcon;
  }
});
Object.defineProperty(exports, "SwordIcon", {
  enumerable: true,
  get: function get() {
    return _SwordIcon.SwordIcon;
  }
});
Object.defineProperty(exports, "TavernIcon", {
  enumerable: true,
  get: function get() {
    return _TavernIcon.TavernIcon;
  }
});
Object.defineProperty(exports, "ThiefIcon", {
  enumerable: true,
  get: function get() {
    return _ThiefIcon.ThiefIcon;
  }
});
Object.defineProperty(exports, "ThumbUpIcon", {
  enumerable: true,
  get: function get() {
    return _ThumbUpIcon.ThumbUpIcon;
  }
});
Object.defineProperty(exports, "TickIcon", {
  enumerable: true,
  get: function get() {
    return _TickIcon.TickIcon;
  }
});
Object.defineProperty(exports, "TimeMageIcon", {
  enumerable: true,
  get: function get() {
    return _TimeMageIcon.TimeMageIcon;
  }
});
Object.defineProperty(exports, "TrashIcon", {
  enumerable: true,
  get: function get() {
    return _TrashIcon.TrashIcon;
  }
});
Object.defineProperty(exports, "TrophyIcon", {
  enumerable: true,
  get: function get() {
    return _TrophyIcon.TrophyIcon;
  }
});
Object.defineProperty(exports, "UndeadIcon", {
  enumerable: true,
  get: function get() {
    return _UndeadIcon.UndeadIcon;
  }
});
Object.defineProperty(exports, "UnlimitedIcon", {
  enumerable: true,
  get: function get() {
    return _UnlimitedIcon.UnlimitedIcon;
  }
});
Object.defineProperty(exports, "UserIcon", {
  enumerable: true,
  get: function get() {
    return _UserIcon.UserIcon;
  }
});
Object.defineProperty(exports, "VerifiedIcon", {
  enumerable: true,
  get: function get() {
    return _VerifiedIcon.VerifiedIcon;
  }
});
Object.defineProperty(exports, "View3dIcon", {
  enumerable: true,
  get: function get() {
    return _View3dIcon.View3dIcon;
  }
});
Object.defineProperty(exports, "VoxelBalanceIcon", {
  enumerable: true,
  get: function get() {
    return _VoxelBalanceIcon.VoxelBalanceIcon;
  }
});
Object.defineProperty(exports, "VoxelIcon", {
  enumerable: true,
  get: function get() {
    return _VoxelIcon.VoxelIcon;
  }
});
Object.defineProperty(exports, "VoxiesLogo", {
  enumerable: true,
  get: function get() {
    return _VoxiesLogo.VoxiesLogo;
  }
});
Object.defineProperty(exports, "VoxiesWhiteOutlineLogo", {
  enumerable: true,
  get: function get() {
    return _VoxiesWhiteOutlineLogo.VoxiesWhiteOutlineLogo;
  }
});
Object.defineProperty(exports, "WalletIcon", {
  enumerable: true,
  get: function get() {
    return _WalletIcon.WalletIcon;
  }
});
Object.defineProperty(exports, "WarriorIcon", {
  enumerable: true,
  get: function get() {
    return _WarriorIcon.WarriorIcon;
  }
});
Object.defineProperty(exports, "WhiteMageIcon", {
  enumerable: true,
  get: function get() {
    return _WhiteMageIcon.WhiteMageIcon;
  }
});
var _ActiveNowIcon = require("./ActiveNowIcon/ActiveNowIcon");
var _AddItemIcon = require("./AddItemIcon/AddItemIcon");
var _AddSquareIcon = require("./AddSquareIcon/AddSquareIcon");
var _AddressIcon = require("./AddressIcon/AddressIcon");
var _AlertFullIcon = require("./AlertFullIcon/AlertFullIcon");
var _AlertIcon = require("./AlertIcon/AlertIcon");
var _AlertInfoIcon = require("./AlertInfoIcon/AlertInfoIcon");
var _AppleIcon = require("./AppleIcon/AppleIcon");
var _ArmorIcon = require("./ArmorIcon/ArmorIcon");
var _ArrowIcon = require("./ArrowIcon/ArrowIcon");
var _ArrowLeftIcon = require("./ArrowLeftIcon/ArrowLeftIcon");
var _ArrowRightIcon = require("./ArrowRightIcon/ArrowRightIcon");
var _ArrowUpDownIcon = require("./ArrowUpDownIcon/ArrowUpDownIcon");
var _BardIcon = require("./BardIcon/BardIcon");
var _BlackMageIcon = require("./BlackMageIcon/BlackMageIcon");
var _BookmarkIcon = require("./BookmarkIcon/BookmarkIcon");
var _BroomIcon = require("./BroomIcon/BroomIcon");
var _BurgerIcon = require("./BurgerIcon/BurgerIcon");
var _CalendarIcon = require("./CalendarIcon/CalendarIcon");
var _ChemistIcon = require("./ChemistIcon/ChemistIcon");
var _ClockIcon = require("./ClockIcon/ClockIcon");
var _CloseIcon = require("./CloseIcon/CloseIcon");
var _CodeIcon = require("./CodeIcon/CodeIcon");
var _CoinIcon = require("./CoinIcon/CoinIcon");
var _CrownIcon = require("./CrownIcon/CrownIcon");
var _DamageCompareIcon = require("./DamageCompareIcon/DamageCompareIcon");
var _DamageIcon = require("./DamageIcon/DamageIcon");
var _DefaultLogoIcon = require("./DefaultLogoIcon/DefaultLogoIcon");
var _DexterityIcon = require("./DexterityIcon/DexterityIcon");
var _DiamondIcon = require("./DiamondIcon/DiamondIcon");
var _DiceIcon = require("./DiceIcon/DiceIcon");
var _DisconnectIcon = require("./DisconnectIcon/DisconnectIcon");
var _DrakoIcon = require("./DrakoIcon/DrakoIcon");
var _DruidIcon = require("./DruidIcon/DruidIcon");
var _DrumIcon = require("./DrumIcon/DrumIcon");
var _EyeIcon = require("./EyeIcon/EyeIcon");
var _EyeIconOutline = require("./EyeIconOutline/EyeIconOutline");
var _EyeSlashIcon = require("./EyeSlashIcon/EyeSlashIcon");
var _FacebookIcon = require("./FacebookIcon/FacebookIcon");
var _FiltersIcon = require("./FiltersIcon/FiltersIcon");
var _FireIcon = require("./FireIcon/FireIcon");
var _GameIcon = require("./GameIcon/GameIcon");
var _GiftIcon = require("./GiftIcon/GiftIcon");
var _GoogleIcon = require("./GoogleIcon/GoogleIcon");
var _GroupSaleIcon = require("./GroupSaleIcon/GroupSaleIcon");
var _HashTagIcon = require("./HashTagIcon/HashTagIcon");
var _HawkKnightIcon = require("./HawkKnightIcon/HawkKnightIcon");
var _HealthIcon = require("./HealthIcon/HealthIcon");
var _ImageCarouselIcon = require("./ImageCarouselIcon/ImageCarouselIcon");
var _InboxIcon = require("./InboxIcon/InboxIcon");
var _InfoCircleIcon = require("./InfoCircleIcon/InfoCircleIcon");
var _InfoIcon = require("./InfoIcon/InfoIcon");
var _IntelligenceIcon = require("./IntelligenceIcon/IntelligenceIcon");
var _KnightIcon = require("./KnightIcon/KnightIcon");
var _LeftArrowWithBackground = require("./LeftArrowWithBackground/LeftArrowWithBackground");
var _LibraryIcon = require("./LibraryIcon/LibraryIcon");
var _LogoIcon = require("./LogoIcon/LogoIcon");
var _LuckIcon = require("./LuckIcon/LuckIcon");
var _MagicIcon = require("./MagicIcon/MagicIcon");
var _MonkIcon = require("./MonkIcon/MonkIcon");
var _MoonIcon = require("./MoonIcon/MoonIcon");
var _MovementIcon = require("./MovementIcon/MovementIcon");
var _NecromancerIcon = require("./NecromancerIcon/NecromancerIcon");
var _NewTextIcon = require("./NewTextIcon/NewTextIcon");
var _NinjaIcon = require("./NinjaIcon/NinjaIcon");
var _NotFoundIcon = require("./NotFoundIcon/NotFoundIcon");
var _NotificationIcon = require("./NotificationIcon/NotificationIcon");
var _OfferIcon = require("./OfferIcon/OfferIcon");
var _PaperPlaneIcon = require("./PaperPlaneIcon/PaperPlaneIcon");
var _PenToSquareIcon = require("./PenToSquareIcon/PenToSquareIcon");
var _PetIcon = require("./PetIcon/PetIcon");
var _PetsPlusVoxelIcon = require("./PetsPlusVoxelIcon/PetsPlusVoxelIcon");
var _PirateIcon = require("./PirateIcon/PirateIcon");
var _PixelArrowIcon = require("./PixelArrowIcon/PixelArrowIcon");
var _PlayIcon = require("./PlayIcon/PlayIcon");
var _PriestIcon = require("./PriestIcon/PriestIcon");
var _RangerIcon = require("./RangerIcon/RangerIcon");
var _RankIcon = require("./RankIcon/RankIcon");
var _RecipeIcon = require("./RecipeIcon/RecipeIcon");
var _RefreshIcon = require("./RefreshIcon/RefreshIcon");
var _RemoveItemIcon = require("./RemoveItemIcon/RemoveItemIcon");
var _RentalIcon = require("./RentalIcon/RentalIcon");
var _ReservedLockIcon = require("./ReservedLockIcon/ReservedLockIcon");
var _ResizeIcon = require("./ResizeIcon/ResizeIcon");
var _RoboIcon = require("./RoboIcon/RoboIcon");
var _SamuraiIcon = require("./SamuraiIcon/SamuraiIcon");
var _SadIcon = require("./SadIcon/SadIcon");
var _SearchIcon = require("./SearchIcon/SearchIcon");
var _ShareIcon = require("./ShareIcon/ShareIcon");
var _ShopIcon = require("./ShopIcon/ShopIcon");
var _SkullIcon = require("./SkullIcon/SkullIcon");
var _SquirrelIcon = require("./SquirrelIcon/SquirrelIcon");
var _StarIcon = require("./StarIcon/StarIcon");
var _StrengthIcon = require("./StrengthIcon/StrengthIcon");
var _SunIcon = require("./SunIcon/SunIcon");
var _SwordIcon = require("./SwordIcon/SwordIcon");
var _TavernIcon = require("./TavernIcon/TavernIcon");
var _ThiefIcon = require("./ThiefIcon/ThiefIcon");
var _ThumbUpIcon = require("./ThumbUpIcon/ThumbUpIcon");
var _TickIcon = require("./TickIcon/TickIcon");
var _TimeMageIcon = require("./TimeMageIcon/TimeMageIcon");
var _TrashIcon = require("./TrashIcon/TrashIcon");
var _TrophyIcon = require("./TrophyIcon/TrophyIcon");
var _UndeadIcon = require("./UndeadIcon/UndeadIcon");
var _UnlimitedIcon = require("./UnlimitedIcon/UnlimitedIcon");
var _UserIcon = require("./UserIcon/UserIcon");
var _VerifiedIcon = require("./VerifiedIcon/VerifiedIcon");
var _View3dIcon = require("./View3dIcon/View3dIcon");
var _VoxiesLogo = require("./Logo/VoxiesLogo");
var _VoxiesWhiteOutlineLogo = require("./Logo/VoxiesWhiteOutlineLogo");
var _VoxelBalanceIcon = require("./VoxelBalanceIcon/VoxelBalanceIcon");
var _VoxelIcon = require("./VoxelIcon/VoxelIcon");
var _WalletIcon = require("./WalletIcon/WalletIcon");
var _WarriorIcon = require("./WarriorIcon/WarriorIcon");
var _WhiteMageIcon = require("./WhiteMageIcon/WhiteMageIcon");